export default "__VITE_ASSET__D14TEr3d__"